import { render, staticRenderFns } from "./VPRPublicationsForm.vue?vue&type=template&id=44f54b4a&scoped=true&"
import script from "./VPRPublicationsForm.vue?vue&type=script&lang=js&"
export * from "./VPRPublicationsForm.vue?vue&type=script&lang=js&"
import style0 from "./VPRPublicationsForm.vue?vue&type=style&index=0&id=44f54b4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f54b4a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VLayout,VRow,VSpacer,VTextField})
